import { type MouseEvent } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';

interface ShareInEmailSelectTemplateFooterProps {
  onGoBack: () => void;
  onClickNewTemplate: (e: MouseEvent<HTMLButtonElement>) => void;
  backTrackingId: string;
  newTemplateTrackingId: string;
}

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--fabric-space-gap-md);
    padding: var(--fabric-space-padding-md);
  `,
};

export const ShareInEmailSelectTemplateFooter = ({
  onGoBack,
  onClickNewTemplate,
  backTrackingId,
  newTemplateTrackingId,
}: ShareInEmailSelectTemplateFooterProps) => {
  const { t } = useTranslation('payments-share-in-email');

  return (
    <div css={styles.container}>
      <Button
        variant='tertiary'
        size='large'
        onClick={onClickNewTemplate}
        iconName='plus'
        trackingId={newTemplateTrackingId}
      >
        {t('New Template')}
      </Button>
      <Button variant='secondary' size='large' onClick={onGoBack} trackingId={backTrackingId}>
        {t('Close')}
      </Button>
    </div>
  );
};
